// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rvNr","colBig":"styles_colBig__3Ra0e","colSmall":"styles_colSmall__2x2u4","shopifyNameWrapper":"styles_shopifyNameWrapper__1KMTs"};